import type { LocaleCode, LocalizedText } from '@fixit/bozp-content';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { resolveLocalized } from './locale';

export interface MarkdownProps {
  markdown: LocalizedText;
  locale?: LocaleCode;
}

/**
 * The one sanitized markdown surface for the renderer. react-markdown does not
 * parse raw HTML (no rehype-raw), and rehype-sanitize strips any dangerous
 * nodes/attributes — together this guarantees authored content cannot inject
 * executable HTML into the player or admin preview.
 */
export function Markdown({ markdown, locale = 'cs-CZ' }: MarkdownProps) {
  const text = resolveLocalized(markdown, locale);
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>
      {text}
    </ReactMarkdown>
  );
}
